import axios, { AxiosInstance } from 'axios';
import { plainToInstance } from 'class-transformer';
import { CustomerDto } from '../commons/dtos/customer.dto';
import { FileLinkDto } from '../commons/dtos/file-link.dto';
import { IChatbotAPIResponse } from '../commons/interfaces/chatbotAPI.interface';
import {
  ICreateCustomerReq,
  ICustomerFileLinkRes,
  ICustomerRes
} from '../commons/interfaces/customer.interface';
import { IFormPhoneValidationReq } from '../commons/interfaces/form-response.interface';

export default class PublicService {
  private request: AxiosInstance;

  constructor() {
    this.request = axios.create({
      baseURL: process.env.REACT_APP_SERVER_HOST,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  validateCustomerPhone = async (requestData: IFormPhoneValidationReq) => {
    const response = await this.request.post<IChatbotAPIResponse<ICustomerRes>>(
      '/customers/phone-numbers/validate',
      requestData
    );

    const data = plainToInstance(CustomerDto, response.data.data);

    return { data };
  };

  createCustomer = async (requestData: ICreateCustomerReq) => {
    const response = await this.request.post<IChatbotAPIResponse<ICustomerRes>>(
      '/customers',
      requestData
    );

    const data = plainToInstance(CustomerDto, response.data.data);

    return { data };
  };

  createCustomerFileLink = async (customerId: string, file: File) => {
    const { name } = file;
    const extension = name.split('.').pop();
    const endpoint = `/customers/${customerId}/file-links`;

    const response = await this.request.post<IChatbotAPIResponse<ICustomerFileLinkRes>>(endpoint, {
      file: {
        extension
      }
    });

    const data = plainToInstance(FileLinkDto, response.data.data);

    return { data };
  };

  uploadFile = async (customerId: string, file: File) => {
    const { data: fileData } = await this.createCustomerFileLink(customerId, file);

    await this.request.put(fileData.url, file, {
      headers: {
        'Content-Type': file.type,
        'Content-Disposition': `attachment;filename=${file.name}`
      }
    });

    const [url] = fileData.url.split('?');
    return url;
  };
}
